module.exports = __webpack_public_path__ + "static/media/REVV.e74a7c36.svg";